'use client';

import React from 'react';
import { Button } from '@skin-seoul/design-system';
interface AddToBagButtonProps {
  onClick: () => void;
  size?: 'mobile' | 'desktop';
  productStatus?: string;
  addToBagStatus?: string;
  hasSelectedOption: boolean;
}
const AddToBagButton = ({
  onClick,
  size = 'desktop',
  productStatus,
  addToBagStatus,
  hasSelectedOption
}: AddToBagButtonProps) => {
  const isMobile = size === 'mobile';
  const isDisabled = productStatus === 'outofstock' || addToBagStatus === 'pending' || !hasSelectedOption;
  return <Button flex={1} height={isMobile ? '40px' : {
    base: '40px',
    tablet: '44px'
  }} border="1px solid" borderColor={isDisabled ? 'neutral.200' : 'primary.600'} backgroundColor="white" color={isDisabled ? 'neutral.400' : 'primary.600'} borderRadius="8px" textStyle={isMobile ? 'label.medium' : {
    base: 'label.medium',
    tablet: 'label.large'
  }} fontWeight="normal" justifyContent="center" _hover={{
    backgroundColor: 'primary.50'
  }} onClick={onClick} disabled={isDisabled} data-sentry-element="Button" data-sentry-component="AddToBagButton" data-sentry-source-file="AddToBagButton.tsx">
      {productStatus === 'outofstock' ? 'Out of Stock' : 'Add to Bag'}
    </Button>;
};
export default AddToBagButton;